import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
import SingletonModel from '../model/singletonModel';

export default class AbstractPage {
    constructor(options) {
        const _ = this;

        _.option = $.extend(
            {
                selector: '',
                scrollMagicController: null,
                emitter: null
            },
            options
        );

        _.model = SingletonModel.getInstance();

        _.proxy = {
            sceneEventHandler: $.proxy(_.scrollMagicEventHandler, _)
        };

        _.emitter = _.option.emitter || null;

        _.scrollMagicScene = null;

        _.$wrap = $(_.option.selector);
    }

    getScrollMagicScene() {
        return this.scrollMagicScene;
    }

    enabledScrollMagicScene(flag) {
        const _ = this;

        if (_.scrollMagicScene) {
            _.scrollMagicScene.enabled(flag);
        }
    }

    resetScrollMagicScene() {
        const _ = this;

        if (_.scrollMagicScene) {
            _.scrollMagicScene.off('enter leave', _.proxy.sceneEventHandler);
            _.scrollMagicScene.destroy();
        }

        _.scrollMagicScene = new ScrollMagic.Scene({
            triggerElement: _.option.selector,
            offset: 0,
            duration: $(_.option.selector).height()
        });

        _.scrollMagicScene.on('enter leave', _.proxy.sceneEventHandler);
    }

    getHeight() {
        const _ = this;
        return _.$wrap.height();
    }

    init(obj = null) {
        // override
        const _ = this;

        _.resetScrollMagicScene();

        // _.scrollMagicScene.on('enter leave', _.proxy.sceneEventHandler);

        return _;
    }

    scrollMagicEventHandler(evt) {
        const _ = this;

        switch (evt.type) {
            case 'enter':
                _.enter();

                _.emitter.emit('ENTER', {
                    page: _
                });

                break;

            case 'leave':
                _.exit();

                break;
        }
    }

    destroy(obj = null) {
        // override
        return this;
    }

    enter(obj = null) {
        // override
        return this;
    }

    exit(obj = null) {
        // override
        return this;
    }

    hide(obj = null) {
        const _ = this;

        _.$wrap.hide();

        return _;
    }

    show(obj = null) {
        const _ = this;

        _.$wrap.show();

        return _;
    }

    resize(evt = null) {
        // override
        return this;
    }

    getSelector() {
        return this.option.selector;
    }
}
